import { useCallback, useEffect, useMemo, useState } from 'react';
import { QuickReplyService } from '../services/quick-reply.service';
import { QuickReplyResponse } from '../services/responses/quick-reply.response';

/// Catálogo de respostas prontas, carregado uma vez por tela aberta.
export const useQuickReplies = () => {
    const [quickReplies, setQuickReplies] = useState<QuickReplyResponse[]>([]);
    const service = useMemo(() => new QuickReplyService(), []);

    const fetchAll = useCallback(async () => {
        try {
            const res = await service.getList();

            setQuickReplies(res.data.data ?? []);
        } catch (e) {
            console.error(e);
        }
    }, [service]);

    useEffect(() => {
        fetchAll();
    }, [fetchAll]);

    return { quickReplies, refetch: fetchAll };
};
